import React from 'react';
import { Link } from 'react-router-dom';
import './DataColumns.scss';
/**
 * data Columns for grid and mobile view
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = () => {
  const dataColumns = [
    {
      field: 'project.name',
      title: 'Project',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 150,
      className: 'grid-cells',
    },
    {
      field: 'version.name',
      title: 'Version',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      className: 'grid-cells',
    },
    {
      field: 'rolloutCount',
      title: '# of Rollout',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      filterable: false,
      cell: (props) => {
        return (
          <td className="total-number">
            <Link
              to={`/rolloutList/${props.dataItem?.project?.id}/${props.dataItem.version.id}`}
              className="k-font-size-md"
            >
              {props.dataItem.rolloutCount}
            </Link>
          </td>
        );
      },
    },
  ];

  return dataColumns;
};
export default DataColumns;
